export default "__VITE_ASSET__DlJmytIp__"